// extracted by mini-css-extract-plugin
export default {"swiperButtons":"SwiperNavButtons_swiperButtons__lymnX","circleButton":"SwiperNavButtons_circleButton__jHiSG"};